
import i18n from '@/i18n.js'
import router from "@/router"
import ReadinessService from '../services/readiness.service';
export default {
    namespaced: true,
    state: () => ({
    }),
    actions: {
        action_reject_report({ commit, rootState }, data) {
            data.append('action', 'reject')
            return ReadinessService.change_status(data).then(
                (response) => {
                    console.log(response.data)
                    if (data.get('page') == 'show')
                        rootState.table.items.map(v => {
                            if (v.id == data.get('readiness_report_id')) {
                                v.status.status = response.data.data.status.status
                                v.status_id = response.data.data.status_id
                                return v;
                            }
                        });
                    else
                        router.push({
                            name: "ReadinessPage",
                            params: { message: { msg: response.data.message, type: "Success" } },
                        });
                    rootState.form.loader = false
                    rootState.form.notify = {
                        msg: response.data.message,
                        type: "Success",
                    };
                    commit('form/SET_DIALOG', false, { root: true })
                },
                (error) => {
                    console.log(error);
                    rootState.form.loader = false
                    if (error.response.status == 422) {
                        var errors = error.response.data.errors;
                        for (
                            let i = 0;
                            i < rootState.form.style_form.length;
                            i++
                        ) {
                            const element = rootState.form.style_form[i];
                            element.error = errors[element.value_text];
                        }
                    } else if (error.response.status != 401) {
                        rootState.form.notify = {
                            msg: i18n.t("general.there is problem"),
                            type: "Danger",
                        };
                    }
                }
            );
        },

        approve_report({ rootState }, data) {
            return ReadinessService.change_status(data).then(
                (response) => {
                    rootState.table.items.map(v => {
                        if (v.id == data.readiness_report_id) {
                            v.status.status = response.data.data.status.status
                            v.status_id = response.data.data.status_id
                            return v;
                        }
                    });
                    return Promise.resolve(response);
                },
                (error) => {
                    console.log(error);
                    return Promise.reject(error);
                }
            );
        },

        cancel_report({ rootState }, data) {
            return ReadinessService.cancel_readiness(data).then(
                (response) => {
                    rootState.table.items.map(v => {
                        if (v.id == data.readiness_report_id) {
                            v.status.status = response.data.data.status.status
                            v.status_id = response.data.data.status_id
                            return v;
                        }
                    });
                    return Promise.resolve(response);
                },
                (error) => {
                    console.log(error);
                    return Promise.reject(error);
                }
            );
        },

        approve_readiness_report({ }, item) {
            return ReadinessService.cancel_order(item.id).then(
                (response) => {
                    // rootState.table.items = rootState.table.items.filter((v) => v.id != item.id);
                    rootState.table.items.map(v => {
                        if (v.id == item.id) {
                            v.status.status = response.data.data.status.status
                            v.status_id = response.data.data.status_id
                            return v;
                        }
                    });
                    return Promise.resolve(response);
                },
                (error) => {
                    console.log(error);
                    return Promise.reject(error);
                }
            );
        },
        action_change_assignation({ commit, rootState }, data) {
            return ReadinessService.change_assignation(data).then(
                (response) => {
                    rootState.table.items.map(v => {
                        if (v.id == data.get('readiness_report_id')) {
                            v.status.status = response.data.data.status.status
                            v.status_id = response.data.data.status_id
                            v.responsible_entity_id = response.data.data.responsible_entity_id
                            v.responsible_entity = response.data.data.responsible_entity
                            return v;
                        }
                    });
                    commit('form/SET_LOADER', false, { root: true })
                    commit('form/SET_DIALOG', false, { root: true });
                    commit("form/SET_NOTIFY", {
                        msg: response.data.message,
                        type: "Success"
                    }, { root: true });

                    // return Promise.resolve(response);
                },
                (error) => {
                    console.log(error);
                    commit('form/SET_LOADER', false, { root: true })
                    commit("form/SET_NOTIFY", {
                        msg: error.response.data.message,
                        type: "Danger"
                    }, { root: true });
                    // return Promise.reject(error);
                }
            );
        },
        action_reject_assignation({ commit, rootState }, data) {
            return ReadinessService.reject_assignation(data).then(
                (response) => {
                    rootState.table.items.map(v => {
                        if (v.id == data.get('readiness_report_id')) {
                            v.status.status = response.data.data.status.status
                            v.status_id = response.data.data.status_id
                            return v;
                        }
                    });
                    commit('form/SET_LOADER', false, { root: true })
                    commit('form/SET_DIALOG', false, { root: true });
                    commit("form/SET_NOTIFY", {
                        msg: response.data.message,
                        type: "Success"
                    }, { root: true });

                    // return Promise.resolve(response);
                },
                (error) => {
                    console.log(error);
                    commit('form/SET_LOADER', false, { root: true })
                    commit("form/SET_NOTIFY", {
                        msg: error.response.data.message,
                        type: "Danger"
                    }, { root: true });
                    // return Promise.reject(error);
                }
            );
        },
        action_assign_contractor({ commit, rootState }, data) {
            return ReadinessService.assign_contractor(data).then(
                (response) => {
                    rootState.table.items.map(v => {
                        if (v.id == data.get('readiness_report_id')) {
                            v.status.status = response.data.data.status.status
                            v.status_id = response.data.data.status_id
                            v.contractor_id = response.data.data.contractor_id
                            v.contractor = response.data.data.contractor
                            return v;
                        }
                    });
                    commit('form/SET_LOADER', false, { root: true })
                    commit('form/SET_DIALOG', false, { root: true });
                    commit("form/SET_NOTIFY", {
                        msg: response.data.message,
                        type: "Success"
                    }, { root: true });

                    // return Promise.resolve(response);
                },
                (error) => {
                    console.log(error);
                    commit('form/SET_LOADER', false, { root: true })
                    commit("form/SET_NOTIFY", {
                        msg: error.response.data.message,
                        type: "Danger"
                    }, { root: true });
                    // return Promise.reject(error);
                }
            );
        },

        action_upload_docs({ commit, rootState }, data) {
            return ReadinessService.upload_docs(data).then(
                (response) => {
                    commit('form/SET_LOADER', false, { root: true })
                    commit('form/SET_DIALOG', false, { root: true });
                    commit("form/SET_NOTIFY", {
                        msg: response.data.message,
                        type: "Success"
                    }, { root: true });

                    if (data.get('page') == 'show')
                        rootState.table.items.map(v => {
                            if (v.id == data.get('readiness_report_id')) {
                                v.status.status = response.data.data.status.status
                                v.status_id = response.data.data.status_id
                                return v;
                            }
                        });
                    else
                        router.push({
                            name: "ReadinessPage",
                            params: { message: { msg: response.data.message, type: "Success" } },
                        });
                    // return Promise.resolve(response);
                },
                (error) => {
                    console.log(error);
                    commit('form/SET_LOADER', false, { root: true })
                    commit("form/SET_NOTIFY", {
                        msg: error.response.data.message,
                        type: "Danger"
                    }, { root: true });
                    // return Promise.reject(error);
                }
            );
        },

        action_update_docs({ commit, rootState }, data) {
            return ReadinessService.update_docs(data).then(
                (response) => {
                    commit('form/SET_LOADER', false, { root: true })
                    commit('form/SET_DIALOG', false, { root: true });
                    commit("form/SET_NOTIFY", {
                        msg: response.data.message,
                        type: "Success"
                    }, { root: true });
                    if (data.get('page') == 'show')
                        rootState.table.items.map(v => {
                            if (v.id == data.get('readiness_report_id')) {
                                v.status.status = response.data.data.status.status
                                v.status_id = response.data.data.status_id
                                v.latest_update = response.data.data.latest_update
                                return v;
                            }
                        });
                    else
                        router.push({
                            name: "ReadinessPage",
                            params: { message: { msg: response.data.message, type: "Success" } },
                        });

                    // return Promise.resolve(response);
                },
                (error) => {
                    console.log(error);
                    commit('form/SET_LOADER', false, { root: true })
                    commit("form/SET_NOTIFY", {
                        msg: error.response.data.message,
                        type: "Danger"
                    }, { root: true });
                    // return Promise.reject(error);
                }
            );
        },

        // pagination section
        handlePageChange({ rootState, dispatch }, page) {
            rootState.table.paginate.page = page
            dispatch("getData", {})
        },

        changeItemPage({ rootState, dispatch }, pre_page) {
            rootState.table.paginate.itemsPerPage = parseInt(pre_page);
            rootState.table.paginate.page = 1;
            dispatch("getData", { pre_page, type: "pre_page" })
        },

        // filter section 
        filterData({ dispatch, rootState }) {
            rootState.table.paginate.page = 1;
            dispatch("getData", {})
        },
        resetFilter({ rootState, dispatch }) {
            rootState.table.paginate.page = 1;
            dispatch("getData", { reset: true })
        },

        getData({ rootState }, data) {
            console.log(data)
            rootState.table.loading = true;
            const formData = new FormData();
            if (!data.hasOwnProperty('reset')) {

                rootState.form.filters.filter(function (filter) {
                    formData.append(filter.name, filter.value);
                });
            }
            if (data.hasOwnProperty('type') && data.type == "pre_page") {
                formData.append(
                    "paginate",
                    data.pre_page
                );
            } else {
                if (rootState.table.paginate.itemsPerPage != '')
                    formData.append(
                        "paginate",
                        rootState.table.paginate.itemsPerPage
                    );
            }
            return ReadinessService.get_readiness(rootState.table.paginate.page, formData).then(
                (response) => {
                    console.log(response.data);
                    rootState.table.items = response.data.data.data
                    rootState.table.paginate = {
                        total: response.data.data.total,
                        itemsPerPage: parseInt(response.data.data.per_page),
                        row_pre_page: true,
                        page: rootState.table.paginate.page,
                    }
                    if (data.hasOwnProperty('reset') && data.reset) {

                        rootState.form.filters = response.data.filters;
                    }
                    rootState.table.loading = false;
                    return Promise.resolve(response);
                },
                (error) => {
                    console.log(error);
                    rootState.table.loading = false;
                    if (error.response.status != 401) {
                        rootState.form.notify = {
                            msg: i18n.t("general.there is problem"),
                            type: "Danger",
                        };
                    }
                    return Promise.reject(error);
                }
            )
        },

    },

};